import "./Toggle.css";

import RcSwitch from "rc-switch";

import { FormLabel } from "../../FormLabel";
import { useToggle } from "./useToggle";

type ToggleVariant = "primary" | "secondary" | "tertiary";

type ToggleSize = "default" | "medium" | "small";

export interface ToggleProps {
  value: boolean;
  variant?: ToggleVariant;
  label?: string;
  size?: ToggleSize;
  allowLabelDangerousHtml?: boolean;
  labelAlignment?: "left" | "right";
  disabled?: boolean;
  onChange: (value: boolean) => void;
}

export const Toggle = ({
  label,
  size = "default",
  variant = "primary",
  allowLabelDangerousHtml,
  labelAlignment = "right",
  disabled = false,
  onChange,
  value,
}: ToggleProps): JSX.Element => {
  const { toggleId, checked, handleToggleClick } = useToggle(value, onChange);

  return (
    <div className={`Toggle ${variant} ${size}`}>
      <FormLabel label={label} labelAlignment={labelAlignment} allowDangerousHtml={allowLabelDangerousHtml}>
        <RcSwitch
          id={toggleId}
          checked={checked}
          disabled={disabled}
          onClick={handleToggleClick}
          prefixCls="ToggleComponent"
        />
      </FormLabel>
    </div>
  );
};
